package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.SkeletonDemo

@Page
@Composable
fun SkeletonPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/skeleton.md", mapOf("title" to listOf("Skeleton"), "description" to listOf("Use to show a placeholder while content is loading.")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import shadcn.ui.components.Skeleton
import web.cssom.ClassName

val SkeletonDemo = FC<Props> {
    div {
        className = ClassName("flex items-center space-x-4")
        Skeleton {
            className = ClassName("h-12 w-12 rounded-full")
        }
        div {
            className = ClassName("space-y-2")
            Skeleton {
                className = ClassName("h-4 w-[250px]")
            }
            Skeleton {
                className = ClassName("h-4 w-[250px]")
            }
        }
    }
}"""){ 
 SkeletonDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Skeleton
""", lang= "kotlin", highlight= "")
            CodeBlock("""Skeleton { className=ClassName("w-[100px] h-[20px] rounded-full") }
""", lang= "kotlin", highlight= "")
        }
    }
}
